import { useEffect } from 'react';

import { useByfunnPulseContext } from '../../../pulse/index.js';

interface ClickTrackOptions {
  objectId: string;
  name: string;
  elementType?: string;
}

export const useTrackClick = () => {
  const { trackClickUIElement } = useByfunnPulseContext();

  return ({ objectId, name, elementType = 'Widget' }: ClickTrackOptions) => {
    trackClickUIElement(
      {
        object: { id: objectId, name, elementType },
      },
      {
        object: { objectId, name, elementType },
        placement: { containerName: 'page' },
      },
    );
  };
};

export const useAutosizeTextArea = (
  textAreaRef: React.RefObject<HTMLTextAreaElement | null>,
  value: string,
) => {
  useEffect(() => {
    const textArea = textAreaRef.current;
    if (textArea) {
      // Reset height so that shrinking works properly.
      textArea.style.height = '28px';
      const scrollHeight = textArea.scrollHeight;
      // Then set the height to the scrollHeight.
      textArea.style.height = scrollHeight + 'px';
    }
  }, [textAreaRef, value]);
};
